export function initSubmenuToggle(options = {}) {
	const { menuSelector = ".main-menu", itemSelector = ".menu-item-has-children", activeClass = "active", breakpoint = 992 } = options;

	const menu = document.querySelector(menuSelector);
	if (!menu) return;

	let activeItem = null;

	function closeAll() {
		if (!activeItem) return;
		activeItem.classList.remove(activeClass);
		activeItem = null;
	}

	function toggleItem(item) {
		if (item === activeItem) {
			closeAll();
			return;
		}
		closeAll();
		item.classList.add(activeClass);
		activeItem = item;
	}

	function onMenuClick(e) {
		const link = e.target.closest(`${itemSelector} > a`);
		if (!link) return;

		e.preventDefault();

		const item = link.closest(itemSelector);
		if (!item) return;

		toggleItem(item);
	}

	function onDocumentClick(e) {
		if (!activeItem) return;
		if (!e.target.closest(menuSelector)) {
			closeAll();
		}
	}

	const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
	const onBreakpoint = () => closeAll();

	menu.addEventListener("click", onMenuClick);
	document.addEventListener("click", onDocumentClick);
	mq.addEventListener("change", onBreakpoint);

	return () => {
		menu.removeEventListener("click", onMenuClick);
		document.removeEventListener("click", onDocumentClick);
		mq.removeEventListener("change", onBreakpoint);
		closeAll();
	};
}
